import { Component, effect, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';

import { DeviceDetailsBreadcrumbsComponentStore } from './device-details-breadcrumbs.component.store';

@Component({
  imports: [
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatProgressSpinnerModule,
    RouterModule,
  ],

  providers: [DeviceDetailsBreadcrumbsComponentStore],
  selector: 'avs-device-details-breadcrumbs',
  styleUrl: './device-details-breadcrumbs.component.scss',
  templateUrl: './device-details-breadcrumbs.component.html',
})
export class DeviceDetailsBreadcrumbsComponent {
  deviceId = input.required<string>();
  protected store = inject(DeviceDetailsBreadcrumbsComponentStore);

  constructor() {
    effect(() => this.store.loadBreadcrumbs(this.deviceId()));
  }
}
